import React from 'react';
import { Grid, Stack, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { PortalConfiguration, PortalConfigurationRenderProps } from '../../types';
import { TasksPortalConfiguration } from '../types';
import { TasksManagementForm } from './TasksManagementForm';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

export const TasksManagement = ({ loading, onSaveConfiguration }: PortalConfigurationRenderProps) => {
  const portalConfiguration = useSelector((state: any) =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.Tasks)
  ) as PortalConfiguration<TasksPortalConfiguration>;

  const handleSave = async (formData: TasksPortalConfiguration) => {
    const configToSave: PortalConfiguration<TasksPortalConfiguration> = {
      ...portalConfiguration,
      jsonDefinition: { config: formData },
    };
    await onSaveConfiguration(configToSave);
  };

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="Tasks Management">
        <RenderWithFallback
          isLoading={!portalConfiguration}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <TasksManagementForm
            isLoading={loading}
            onConfirm={handleSave}
            defaultValues={portalConfiguration?.jsonDefinition?.config}
          />
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
